import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';

const Table = styled(Box)`
    display: table;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    position: relative;
    z-index: 0;
`;
const Styled = {
  Table
};

export { Styled };
//# sourceMappingURL=styled.es.js.map
